// 20.2.2.33 Math.tanh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/.store/core-js@2.6.12/~/core-js/modules/es6.math.tanh.js
// module id = 728
// module chunks = 75